import { io } from "socket.io-client";

const Socket = io(process.env.VUE_APP_SOCKET_URL,{
  transports: ['websocket'],
  autoConnect: false
});

export default Socket;
